import { useState } from 'react'
import FileSaver from 'file-saver'
import { useUploadFile } from '@/shared/model/useUploadFile'
import { ExpertiseFile } from '../lib/expertise-detail.types'

export function useExpertiseFiles(expertiseId: string) {
  const [upload] = useUploadFile()
  const [downloadingKey, setDownloadingKey] = useState<string | null>(null)

  const uploadFile = (file: File) => upload(file, expertiseId, 'expertise')

  const downloadFile = async (file: ExpertiseFile) => {
    if (!file.url) return
    setDownloadingKey(file.key)
    try {
      const response = await fetch(file.url)
      if (response.ok && response.status === 200) {
        const blob = await response.blob()
        FileSaver.saveAs(blob, file.filename)
      }
    } catch (err) {
      console.error('Error downloading file:', err)
    } finally {
      setDownloadingKey(null)
    }
  }

  return { downloadingKey, uploadFile, downloadFile }
}
